import React, { useEffect } from 'react';
import CalendarSVG from '../assets/Calendar'; 
import config from '../utils/config'; 
import GoogleCalendarSVG from '../assets/GoogleCalendar';

function AddToCalendarButton({ dates }) {
    const handleAddToCalendar = async () => {
        localStorage.setItem('dates', JSON.stringify(dates));
        const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID; 
        // const redirectUri = 'https://www.shishito-re.com';
        // const redirectUri = 'http://localhost:5173'; // Change this to your redirect URI
        const redirectUri = `${window.location.origin}/callback`; // Dedicated callback page
        const scope = 'https://www.googleapis.com/auth/calendar.events';
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=token&scope=${scope}`;

        window.location.href = authUrl;
    };

    return (
        <button onClick={handleAddToCalendar} className='text-[11px] md:text-[15px] font-slate-700 border rounded-md border-slate-700 bg-white p-1 md:p-1.5 hover:bg-slate-400 w-auto inline-flex items-center gap-2'>
            {<GoogleCalendarSVG width={18} height={18}/>} Add to Google
        </button>
    );
}

export default AddToCalendarButton;